module.exports = __webpack_public_path__ + "f767a265ed1d7a44f24c28e371640b2f.svg";